module.exports = __webpack_public_path__ + "components/MapControl/gravePopup/img/znicz2.png?b2e46a8e";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/gravePopup/img/znicz2.png
// module id = 1891
// module chunks = 0